import React from "react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

// Official store badges hosted by Apple and Google, intended for store links.
// Google's badge carries mandated clear-space padding, so it renders taller to
// make the two logos read as the same visual size.
const APPLE_BADGE = "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg";
const GOOGLE_BADGE = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";

const comingSoon = (store) =>
  toast("Coming soon", {
    description: `Next Time isn't on the ${store} just yet. Check back soon!`,
  });

export function AppStoreBadges({ className }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      <button
        data-testid="landing-download-app-store"
        type="button"
        aria-label="Download on the App Store"
        onClick={() => comingSoon("App Store")}
        className="inline-flex items-center transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0"
      >
        <img src={APPLE_BADGE} alt="Download on the App Store" className="h-10 w-auto" draggable={false} />
      </button>
      <button
        data-testid="landing-download-google-play"
        type="button"
        aria-label="Get it on Google Play"
        onClick={() => comingSoon("Google Play Store")}
        className="inline-flex items-center transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0"
      >
        <img src={GOOGLE_BADGE} alt="Get it on Google Play" className="h-[58px] w-auto" draggable={false} />
      </button>
    </div>
  );
}
